<div class="position-relative">
	<button type="button" class="close" aria-label="Close" (click)="closeModal()">
		<span aria-hidden="true">&times;</span>
	</button>
	<div class="panel-title"> {{ roleTypeEdit ? 'Edit' : roleTypeView ? 'View' :
		'Add' }}
		Role Type</div>
	<!-- <ngx-loading [show]="loading"></ngx-loading> -->

    <form [formGroup]="roleTypeForm" (ngSubmit)="onSubmit()" novalidate>
        <div class="make-responsive">
            <div class="mt-top-2 field">
                <mat-form-field class="field">
                    <mat-label>Role Type</mat-label>
                    <input matInput formControlName="roletype">
                    <ng-container *ngIf="formSubmitted && formValues['roletype'].errors">
                        <mat-error *ngIf="formValues['roletype'].errors?.['required']">
                            <em class="fas fa-exclamation-circle mr-2"></em>Role Type is required
                        </mat-error>
                        <mat-error *ngIf="formValues['roletype'].errors?.['pattern']">
                            <em class="fas fa-exclamation-circle mr-2"></em>Remove white space from start and end 
                        </mat-error>
                    </ng-container>
                </mat-form-field>
            </div>
            <div class="mt-top-2 field -hex-code-input-field">
                <mat-form-field>
                    <mat-label>Color</mat-label>
										<span class="d-flex align-items-center mt-1 mb-1 hex-style">
											<input matInput formControlName="color" type="color" class="color">
											<span>HEX CODE:</span> <a id="hex_code">{{formValues['color'].value}}</a></span>
                    <ng-container *ngIf="formSubmitted && formValues['color'].errors">
                        <mat-error *ngIf="formValues['color'].errors?.['required']">
                            <em class="fas fa-exclamation-circle mr-2"></em>Color is required
                        </mat-error>
                    </ng-container>
                    <!-- <ngx-mat-color-toggle matSuffix [for]="picker"></ngx-mat-color-toggle>
                    <ngx-mat-color-picker #picker [touchUi]="touchUi" [color]="color"></ngx-mat-color-picker> -->
				</mat-form-field>
			</div>
			<div class="modal-form d-flex -text-area-field-height">
				<mat-form-field>
					<mat-label>Color Description</mat-label>
					<textarea matInput cdkTextareaAutosize formControlName="colorDesc" #autosize="cdkTextareaAutosize"
						cdkAutosizeMinRows="1" cdkAutosizeMaxRows="5"></textarea>
					<ng-container *ngIf="formSubmitted && formValues['colorDesc'].errors">
						<mat-error *ngIf="formValues['colorDesc'].errors?.['required']">
							<em class="fas fa-exclamation-circle mr-2"></em>Color Description is required
						</mat-error>
						<mat-error *ngIf="formValues['colorDesc'].errors?.['pattern']">
							<em class="fas fa-exclamation-circle mr-2"></em>Remove white space from start and end
						</mat-error>
					</ng-container>
				</mat-form-field>
			</div>
		</div>
		<div class="d-flex justify-content-center">
			<div class="err-mssg-domain text-danger mb-2" *ngIf="errorMessage"><em
					class="fas fa-exclamation-circle mr-2"></em>{{errorMessage}}</div>
		</div>
		<div class="btn-basket">
			<button mat-raised-button color="primary" data-dismiss="modal" type="button" (click)="closeModal()">Close</button>
			<button *ngIf="!roleTypeView" mat-raised-button color="primary" type="submit">
				{{ roleTypeEdit ? 'Update' : 'Submit' }}
			</button>
		</div>
	</form>
</div>